// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import TerceraClosePositionBodyTemplate from '@front/templates/TerceraClosePositionBodyTemplate.html';
import PositionExerciseRequestScreenFooterTemplate from '@front/templates/PositionExerciseRequestScreenFooterTemplate.html';
import { Control } from '../elements/Control';
import { ScreensNames } from '../UtilsClasses/FactoryConstants';
import { TerceraClosePositionScreen } from '../screen/TerceraClosePositionScreen';
import { positionExerciseRequestScreenHandler } from '@shared/utils/AppHandlers';
import { DataCache } from '@shared/commons/DataCache';
import { MainWindowManager } from '../UtilsClasses/MainWindowManager';
import { PositionExerciseOptionValidator } from '@shared/commons/UtilsClasses/PositionExerciseOptionValidator';
export class PositionExerciseRequestScreen extends TerceraClosePositionScreen {
    constructor() {
        super();
    }
    getType() {
        return ScreensNames.PositionExerciseRequestScreen;
    }
    static show(position, placedFrom) {
        const screen = MainWindowManager.Factory.addScreen(ScreensNames.PositionExerciseRequestScreen);
        screen.set('position', position);
        screen.set('placedFrom', placedFrom);
        screen.center();
    }
    oncomplete() {
        // TerceraClosePositionScreen.prototype.oncomplete.apply(this); // переопределим complete без вызова базового чтоб не создавать лишние контролы
        this.FPosition = null;
        super.oncomplete();
        this.on('exerciseBtnClick', this.exerciseBtnClick);
        this.on('cancelBtnClick', this.cancelBtnClick);
        const position = this.get('position');
        void this.fillByPositionAsync(position);
        this.FPosition = position;
        this.exerciseValidator = new PositionExerciseOptionValidator(position);
        Control.Ticker.Subscribe(this.TickAsync, this);
        void this.set({
            partialCloseAllowed: false, // скрытие нумерика и лейбла Quantity to close
            exerciseBtnEnabled: true,
            exerciseBtnTooltip: ''
        });
    }
    oninit() {
        super.oninit();
        this.localize();
    }
    exerciseBtnClick() {
        const pos = this.get('position');
        const placedFrom = this.get('placedFrom');
        if (pos) {
            DataCache.ExerciseOptionsByPosition(pos, placedFrom);
        }
        this.close();
    }
    cancelBtnClick() {
        this.close();
    }
    localize() {
        super.localize();
        void this.set({
            header: Resources.getResource('screen.PositionExerciseRequestScreen.title'),
            exerciseBtnText: Resources.getResource('screen.PositionExerciseRequestScreen.exercise'),
            cancelBtnText: Resources.getResource('screen.closePosition.cancel')
        });
        this.exerciseError = Resources.getResource('screen.PositionExerciseRequestScreen.exerciseError');
    }
    TickAsync() {
        super.TickAsync();
        const isExerciseBtnEnabled = this.get('exerciseBtnEnabled');
        const isAllowExercise = this.exerciseValidator.isAllowExercise();
        if (isExerciseBtnEnabled !== isAllowExercise) {
            const exercisetooltip = isAllowExercise ? '' : this.exerciseError;
            void this.set({
                exerciseBtnEnabled: isAllowExercise,
                exerciseBtnTooltip: exercisetooltip
            });
        }
    }
    dispose() {
        this.exerciseValidator.dispose();
        Control.Ticker.UnSubscribe(this.TickAsync, this);
        super.dispose();
        // TerceraClosePositionScreen.prototype.dispose.apply(this);    // поскольку oncomplete свой то и dispose также
    }
    static PositionExerciseRequestScreenHandlerInitialize() {
        positionExerciseRequestScreenHandler.show = PositionExerciseRequestScreen.show;
    }
}
TerceraClosePositionScreen.extendWith(PositionExerciseRequestScreen, {
    data: function () {
        return {
            width: 400,
            position: null,
            movable: true,
            showHeader: true,
            showBorder: true,
            placedFrom: null,
            isRelativeStyle: false
        };
    },
    partials: {
        bodyPartial: TerceraClosePositionBodyTemplate,
        footerPartial: PositionExerciseRequestScreenFooterTemplate
    }
});
